import { render, staticRenderFns } from "./ServiceAgentFilesList.vue?vue&type=template&id=4f2772e8&"
import script from "./ServiceAgentFilesList.vue?vue&type=script&lang=js&"
export * from "./ServiceAgentFilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports